module.exports = {
    locale_name: 'Español',
    locale_shorthand: ['es', 'español'],
    // Translations:
    justifyCenter: 'Centrar',
    justifyLeft: 'Justificar a la izquierda',
    justifyRight: 'Justificar a la derecha',
    bold: 'Negrita',
    code: 'Código',
    headings: 'Encabezados (h1-h6)',
    link: 'Hipervínculo',
    image: 'Insertar imagen',
    italic: 'Cursiva',
    orderedList: 'Lista ordenada',
    unorderedList: 'Lista desordenada',
    removeFormat: 'Eliminar formato.\nBorra encabezados, negritas, cursiva, subrayado, etc.',
    separator: null,
    table: 'Insertar tabla',
    underline: 'Subrayado'
}
